import { ErrorMessage, Field, useFormikContext } from 'formik'
import classNames from 'classnames'
import { getValueByName } from './InputUsernameLogin'
import { FormLabel } from '../genericComponents/layout/FormLabel'

export const InputGreenNoDecoration: React.FC<{
  type?: string
  label?: string
  placeholder?: string
  name: string
  className?: string
  classNameForInput?: string
  disabled?: boolean
  autocompleteOff?: boolean
  autoFocus?: boolean
}> = (props) => {
  const { values } = useFormikContext()
  const value = getValueByName(props.name, values)

  return (
    <div className={props.className}>
      {props.label && <FormLabel>{props.label}</FormLabel>}
      <div className="flex row items-center no-wrap w-full">
        <Field
          autoFocus={props.autoFocus}
          type={props.type}
          name={props.name}
          className={classNames(
            props.classNameForInput,
            `text-sm pl-2 h-12 my-2 w-full softlock-new outline-none
            border-borderColor border-b-2 focus:border-primaryAccentColor`
          )}
          value={value || ''}
          placeholder={props.placeholder}
          {...(props.disabled ? { disabled: true } : {})}
          autoComplete={props.autocompleteOff ? 'off' : ''}
        />

        <p></p>
      </div>
      <ErrorMessage className="text-alertColor" name={props.name} component="div" />
    </div>
  )
}
